import { FCC } from '@eluve/components';
import { AppointmentContextProvider } from '@eluve/frontend-appointment-hooks';
import { useTenantIdFromParams } from '@eluve/session-helpers';

import { useTranscriptionMachineSelector } from '../hooks/useTranscriptionMachine';

export const ActiveAppointmentContextProvider: FCC = ({ children }) => {
  const tenantId = useTenantIdFromParams();
  const appointmentId = useTranscriptionMachineSelector(
    (s) => s.context.appointmentId,
  );

  // We always want to provide the AppointmentContext.
  // Previously, we conditionally rendered it based on the presence of appointmentId and tenantId
  // but that lead to issues where all children would be remounted when these values changed
  return (
    <AppointmentContextProvider
      tenantId={tenantId ?? ''}
      appointmentId={appointmentId ?? ''}
    >
      {children}
    </AppointmentContextProvider>
  );
};
